exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-container a:hover,\n.contact-container a:hover h5 {\n  text-decoration: none;\n  color: #666;\n}\n.contact-container a,\n.contact-container h5 {\n  color: #666;\n}\n.contact-container .sau-bx:hover {\n  border: 1px solid #666;\n}\n.break-word {\n  word-break: break-all;\n}\n", ""]);

// exports
